module.exports = __webpack_public_path__ + "static/EnmTX_BosLucia_L_A_cl-45e7c9bbcae6fc2d2e79928c52b1c94d.gif";